import { API } from '../../API/api';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { setIsVehicleProvidedAction, setValueAction as setLastUsedConfigurator, setVehicleNotProvidedCommentAction } from '../../_flux/actions/last_used_configurator_actions';
import {
    setValuesAction as setVehicleConfiguratorValuesAction
} from '../../_flux/actions/vehicle_configurator_actions';
import {
    setTyreOptionsAction as setRegoLookupTyreOptions,
    setValuesAction as setRegoLookupValuesAction,
    setVehicleData,
    enableButtonConfirmAction,
    disableButtonConfirmAction,
} from '../../_flux/actions/rego_lookup_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import CatalogTyreFilterStore from '../../_flux/stores/catalog_filter_store/tyre';
import { resetConfiguratorData } from '../../_views/configurator_buttons/configurator_buttons';
import { requestSetConfiguratorSource } from '../requests/request_set_configurator_source';

const REQUEST_CONFIG = {
    apiPath: '/api/v2/vehicle/configuratordata/',
    data: '',
    dataType: 'json'
};

export const onSuccess = response => {
    const { configuratorSource, vehicleDetails, vehicleList, vehicleConfiguratorFilterOptions, isVehicleProvided, vehicleNotProvidedComment } = response;
    setLastUsedConfigurator(configuratorSource);
    setIsVehicleProvidedAction(isVehicleProvided);
    setVehicleNotProvidedCommentAction(vehicleNotProvidedComment);

    if (configuratorSource === 'vehicle_configurator') {
        setSearchForTyreData(configuratorSource, vehicleDetails);
        vehicleDetails.details = vehicleDetails.vehicleId;

        let filterState = CatalogTyreFilterStore.getState();
        if ('' !== filterState[Filters.WIDTH] && '' !== filterState[Filters.DIAMETER]) {
            let profile = ('' == filterState[Filters.HEIGHT]) ? '0' : filterState[Filters.HEIGHT];
            let tyreSizeValue = filterState[Filters.WIDTH] + '|' + profile + '|' + filterState[Filters.DIAMETER];
            let selectedTyre = '';
            for (let i = 0; i < vehicleConfiguratorFilterOptions[Filters.VEHICLE_TYRES].length; i++) {
                if (vehicleConfiguratorFilterOptions[Filters.VEHICLE_TYRES][i][0].includes(tyreSizeValue)) {
                    selectedTyre = vehicleConfiguratorFilterOptions[Filters.VEHICLE_TYRES][i][0];
                    vehicleDetails[Filters.VEHICLE_TYRES] = selectedTyre;
                    break;
                }
            }
        }

        setVehicleConfiguratorValuesAction(vehicleDetails);
        updateFilterOptionsAction(vehicleConfiguratorFilterOptions);
    }

    if (configuratorSource === 'rego_lookup') {
        setSearchForTyreData(configuratorSource, vehicleDetails);
        let filterState = CatalogTyreFilterStore.getState();
        if ('' !== filterState[Filters.WIDTH] && '' !== filterState[Filters.DIAMETER]) {
            let profile = ('' == filterState[Filters.HEIGHT]) ? '0' : filterState[Filters.HEIGHT];
            let tyreSizeValue = filterState[Filters.WIDTH] + '|' + profile + '|' + filterState[Filters.DIAMETER];
            let selectedTyre = '';
            for (let i = 0; i < vehicleConfiguratorFilterOptions[Filters.VEHICLE_TYRES].length; i++) {
                if (vehicleConfiguratorFilterOptions[Filters.VEHICLE_TYRES][i][0].includes(tyreSizeValue)) {
                    selectedTyre = vehicleConfiguratorFilterOptions[Filters.VEHICLE_TYRES][i][0];
                    vehicleDetails[Filters.VEHICLE_TYRES] = selectedTyre;
                    break;
                }
            }
        }

        setVehicleData(vehicleList);
        setRegoLookupValuesAction(vehicleDetails);
        disableButtonConfirmAction();
        if (1 === vehicleList.length) {
            enableButtonConfirmAction();
            setRegoLookupTyreOptions(vehicleList[0][Filters.VEHICLE_TYRES]);
        }
    }
};

export const onError = error =>
    console.warn('Couldn\'t fetch vehicle configurator data');

export const getData = () => API
    .POST(REQUEST_CONFIG)
    .then(onSuccess)
    .catch(onError);

export const loadVehicleConfiguratorData = async function () {
    try {
        await getData();
    } catch (error) {
        console.warn('Couldn\'t fetch vehicle configurator data: ' + error);
    }
};

const setSearchForTyreData = (type, selectedObj, invert) => {
    const selectedClass = 'header-section-configurator-ribbon-selected';
    let textElems = null;
    let resetValue = 'Tyre Size';
    let selectedVal = '';

    if (type === 'rego_lookup') {
        resetValue = 'Rego';
        selectedVal = selectedObj.registration;
        textElems = document.querySelectorAll('#header-section-configurator-ribbon-rego');
    } else if (type === 'vehicle_configurator') {
        resetValue = 'Vehicle';
        textElems = document.querySelectorAll('#header-section-configurator-ribbon-vehicle');
    } else {
        textElems = document.querySelectorAll('#header-section-configurator-ribbon-tyre-size');
    }

    const statusElems = document.querySelectorAll('.header-section-configurator-ribbon-status'); 
    statusElems.forEach(statusElem => {
        statusElem.style.display = invert ? 'block' : 'none';
    });

    if (textElems.length) {
        textElems.forEach(textElem => {
            textElem.title = invert ? resetValue : selectedVal || `${selectedObj.make} ${selectedObj.model}`;
            textElem.innerHTML = invert ? resetValue : selectedVal || `${selectedObj.make} ${selectedObj.model}`;
            
            if (invert) {
                textElem.classList.remove(selectedClass);
            } else {
                textElem.classList.add(selectedClass);
            }
        });

        const resetElems = document.querySelectorAll('.header-section-configurator-ribbon-reset');
        resetElems.forEach(resetElem => {
            resetElem.style.display = invert ? 'none' : 'flex';

            if (!invert) {
                resetElem.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    requestSetConfiguratorSource('none').then(() => {
                        resetConfiguratorData();
                        setSearchForTyreData(type, selectedObj, true);
                    });
                });
            } else {
                resetElem.removeEventListener('click', () => {
                    requestSetConfiguratorSource('none').then(() => {
                        resetConfiguratorData();
                        setSearchForTyreData(type, selectedObj, true);
                    });
                });
            }
        });
    }

    return this;
}
